import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { CoverImageSize } from '@ui/cover/types';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { first, map, tap } from 'rxjs/operators';
import { ZalamoDialogService } from '@ui/zalamo-dialog/zalamo-dialog.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UploadService } from 'ZalamoLibrary/src/lib/upload/upload.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';
import { RxjsOperators } from 'ZalamoLibrary/src/lib/core/operators/RxjsOperators';

``;

@Component({
    selector: 'lib-tablo-smart-crop',
    templateUrl: './tablo-smart-crop.component.html',
    styleUrls: ['./tablo-smart-crop.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TabloSmartCropComponent
  extends AliveState
  implements OnInit, OnDestroy
{
  get imageSize(): CoverImageSize {
    return this._imageSize;
  }

  @Input() set imageSize(value: CoverImageSize) {
    this.fromRangeUpdate = false;

    this._imageSize = value;
    this.recalculate$.next(undefined);
  }
  @Input() selectedPoint = false;
  private _imageSize: CoverImageSize = { w: 1200, h: 150 };

  @HostBinding('class.isHorizontal') get isHorizontal() {
    return (
      this.imageContainer?.nativeElement.naturalWidth >
      this.imageContainer?.nativeElement.naturalHeight
    );
  }
  xInPx = 100;
  yInPx = 100;
  transition = [];
  widthPhoto = 100;
  heightPhoto = 100;
  widthText = 90;
  heightText = 25;
  xText = 100;
  yText = 100;
  sizeText = 10;
  numberW = 0;
  numberH = 0;
  @Input() fileName: string;
  @ViewChild('ball', {
    static: false,
    read: CdkDrag,
  })
  ballElement: CdkDrag;
  @ViewChild('photoContainer', {
    static: true,
  })
  photoContainer: ElementRef<HTMLElement>;
  @ViewChild('imageContainer', {
    static: false,
  })
  imageContainer: ElementRef<HTMLImageElement>;
  @Output()
  updatedEmitter = new EventEmitter<{
    x: number;
    y: number;
  }>();
  @Input() context;
  @Input() contextId;
  @Output() saved = new EventEmitter<{
    x: number;
    y: number;
    size: {
      w: number;
      h: number;
    };
    file: string;
    url: string;
  }>();
  isPhonePortrait$ = this.screenObserver
    .observe(Breakpoints.Handset)
    .pipe(map(({ matches }) => matches));

  _y = 50;

  get y(): number {
    return this._y;
  }

  @Input() set y(value: number) {
    this._y = value;
    if (this.calculated && !this.fromRangeUpdate) {
      this.debounceTime = 50;
      this.recalculate$.next(undefined);
    }
  }

  private _x = 50;
  fromRangeUpdate = false;
  get x(): number {
    return this._x;
  }

  @Input() set x(value: number) {
    this._x = value;
    if (this.calculated && !this.fromRangeUpdate) {
      this.debounceTime = 0;
      this.recalculate$.next(undefined);
    }
  }
  set localX(value: number) {
    this._x = value;
    this.recalculate$.next(undefined);
  }
  set localY(value: number) {
    this._y = value;
    this.recalculate$.next(undefined);
  }
  get localX() {
    return this._x;
  }
  get localY() {
    return this._y;
  }

  @Input() private _url;

  get url() {
    return this._url;
  }

  @Input() set url(value) {
    if (typeof value === 'string') {
      this._url = this.sanitizer.bypassSecurityTrustUrl(value);
    } else {
      this._url = value;
    }
    this.fromRangeUpdate = false;

    if (this.calculated) {
      this.debounceTime = 50;
      this.recalculate$.next(undefined);
    }
  }

  recalculate$ = new Subject();
  calculated = false;
  resizeObserverSub = null;
  debounceTime = 50;
  ratio = new BehaviorSubject<number>(1);
  constructor(
    private photo: ElementRef<HTMLElement>,
    private screenObserver: BreakpointObserver,
    private dialog: ZalamoDialogService,
    private sanitizer: DomSanitizer,
    private uploadService: UploadService,
    private cd: ChangeDetectorRef,
  ) {
    super();
    console.log(Breakpoints);
  }

  @HostListener('document:keydown', ['$event']) keydown(event: KeyboardEvent) {
    console.log({ event });
    if (event.code === 'ArrowLeft') {
      this._x -= 1;
      this.fromRangeUpdate = true;
      this.calc();
    }
    if (event.code === 'ArrowRight') {
      this._x += 1;
      this.fromRangeUpdate = true;
      this.calc();
    }
    if (event.code === 'ArrowUp') {
      this._y -= 1;
      this.fromRangeUpdate = true;
      this.calc();
    }
    if (event.code === 'ArrowDown') {
      this._y += 1;
      this.fromRangeUpdate = true;
      this.calc();
    }
  }
  @HostListener('window:resize') resize() {
    this.calc();
  }

  onDestroy() {
    this.recalculate$.complete();
    this.recalculate$.unsubscribe();
    if (this.resizeObserverSub) {
      this.resizeObserverSub.disconnect();
    }
  }
  ngOnInit() {
    // @ts-ignore
    const resizeObserver = new ResizeObserver((entries) => {
      this.recalculate$.next(undefined);
    });

    this.resizeObserverSub = resizeObserver.observe(
      this.photoContainer.nativeElement,
    );
    this.calc();
    this.calculated = true;
    this.subscribeWhileAlive(
      this.recalculate$.pipe(
        tap(() => {
          this.debounceTime = 50;
          this.calc();
        }),
      ),
    );
  }

  calc() {
    /**
     * obliczanie contenera zdjecia
     */
    this.isPhonePortrait$
      .pipe(RxjsOperators.elementExists(this, 'imageContainer'), first())
      .subscribe((phone) => {
        const { height, width } =
          this.imageContainer.nativeElement.getBoundingClientRect();
        this._imageSize.w = this.imageContainer.nativeElement.clientWidth;
        this._imageSize.h = this.imageContainer.nativeElement.clientHeight;
        console.log(
          'wysokość zdjęcia',
          this._imageSize.h,
          'szerokość zdjęcia',
          this._imageSize.w,
        );
        this.numberW = 1;
        this.numberH = 1;
        this.ratio.next(
          this.imageContainer.nativeElement.naturalWidth /
            this.imageContainer.nativeElement.naturalHeight,
        );
        this.heightPhoto = this._imageSize.h / this.numberH;
        this.widthPhoto = this._imageSize.w / this.numberH;
        console.log(
          'wysokość zdjęcia po przeliczeniu',
          this.heightPhoto,
          'szerokość zdjęcia po przeliczeniu',
          this.widthPhoto,
        );
        /**
         * obliczanie rozmiaru i pozycji napisu na zdjęciu
         */
        this.widthText = (this.widthPhoto / 100) * 80;
        this.heightText = this.widthText / 20;
        this.xText = (this.widthPhoto - this.widthText) / 2;
        this.yText = (this.heightPhoto - this.heightText) / 2;
        this.xText = this.xText - (this.xText / 100) * 30;
        this.yText = this.yText - (this.yText / 100) * 3;
        if (this.widthPhoto >= this.heightPhoto) {
          this.sizeText = this.xText / 1.8;
        }
        if (this.widthPhoto < this.heightPhoto) {
          this.sizeText = this.yText / 18;
        }
        this.yInPx = (this.y / 100) * this.heightPhoto - 7.5;
        this.xInPx = (this.x / 100) * this.widthPhoto - 7.5;
        console.log({ fromRangeUpdate: this.fromRangeUpdate });
        if (this.fromRangeUpdate) {
          this.updatedEmitter.emit({
            x: this._x,
            y: this._y,
          });
        }
      });
  }

  clickPoint(event: MouseEvent): void {
    this.selectedPoint = true;
    this.transition = ['.4s'];

    // @ts-ignore
    if (event.target.classList.contains('ball')) {
      return;
    }
    this.xInPx = event.offsetX - 7.5;
    this.yInPx = event.offsetY - 7.5;
    this._x = (event.offsetX / this.widthPhoto) * 100;
    this._y = (event.offsetY / this.heightPhoto) * 100;
    console.log('procenty x', this._x, 'procenty y', this._y);
    this.ballElement?.reset();
    this.updatedEmitter.emit({
      x: this._x,
      y: this._y,
    });
  }

  startDrag() {
    this.transition = [`0s`];
  }

  endDrag() {
    this._x =
      ((this.xInPx + this.ballElement.getFreeDragPosition().x) /
        this.widthPhoto) *
      100;
    this._y =
      ((this.yInPx + this.ballElement.getFreeDragPosition().y) /
        this.heightPhoto) *
      100;
    console.log('procenty x', this._x, 'procenty y', this._y);
    this.updatedEmitter.emit({
      x: this._x,
      y: this._y,
    });
  }

  save() {
    this.saved.emit({
      x: this._x,
      y: this._y,
      size: this._imageSize,
      url: this.url,
      file: this.fileName,
    });
  }
}
